import { Component, OnInit, Input,OnDestroy,OnChanges, SimpleChanges, Output, EventEmitter, AfterContentInit } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { getDocumento } from 'src/app/config/procedimientos_registros';
import { informes } from 'src/app/config/models';
import { urlUpload } from 'src/app/config/config';
import { environment } from 'src/environments/environment';
import { CategoriaService } from 'src/app/services/categorias/categoria';
import { ImageConfigService } from 'src/app/services/image-config/image-config.service';


declare var $:any;




@Component({
  selector: 'app-imprimir-informe-cabecera',
  templateUrl: './imprimir-informe-cabecera.component.html',
  styleUrls: ['./imprimir-informe-cabecera.component.css'],
  providers:[ImprimiService,FirmaService]
})

export class ImprimirInformeCabeceraComponent implements OnInit,OnDestroy,OnChanges,AfterContentInit{

    @Input() title: string = '';
    @Input() id: string = '';
    @Input() database: string = '';
    @Input() field: string = '';
    @Input() fecha: string = '';
    @Input() procedimiento: string = '';
    @Input() numero_anexo: string = '';
    @Input() id_registro : string = '';
    @Input() informe_revision : string = '';

    //public database:string = 'agua_cloro';
    public appName = environment.appName;
    public registro = '';
    public procedimiento2 = '';
    public numero_anexo2 = '';
    public id_registro2 = '';
    public anexo = new Date();
    public productos:any = [];
    public oldId = '';
    public baseUrl = urlUpload + 'firmas/';
    // public logo = urlUpload + "/logo.jpg";
    public logo: string
    public rev: string = '';
    public documento: informes ;

    
    public numRevision: string;
    public fechaRevision: string;
    public arrayRevisiones: any[] = []

    public fechaRevisionValid: boolean;
    public fechaValid: boolean;

    constructor(
        private fechaService:FechasService,
        private imprimirService:ImprimiService,
        private firmaService : FirmaService,
        private ImageBaseService: ImageBaseService,
        private categoriaService: CategoriaService,
        private imageConfigService: ImageConfigService
        ){
            this.oldId = this.id;
    }

    ngAfterContentInit(): void {
        //this.mostrarContenido();
    }

    ngOnInit(): void { 
        if (this.field === 'PesoPitufo'){
            this.field = 'pesos'
        }
        this.categoriaService.listarCategoria(this.field).subscribe((resp:any) => {

            this.arrayRevisiones = resp.producto
            this.actualizarRevisionYFecha()
        })

       let id_documento_registro = localStorage.getItem('id_documento_registro');
       if (id_documento_registro != null && id_documento_registro.length > 0 ) {

        this.documento = getDocumento(id_documento_registro);
        this.title = this.documento.title.toUpperCase() || 'INFORME';

        this.procedimiento2 = this.documento.procedimiento_num || ' X';
        this.informe_revision = this.documento.revision || 'Rev.';
        this.numero_anexo2 = this.documento.registro_num || 'X';
       } else {

       }
       
    this.imageConfigService.currentLogo.subscribe(logo => this.logo = logo);

    }
    ngOnDestroy(): void {

    }
    ngOnChanges(changes: SimpleChanges) {
        if ( (this.fecha == null || this.fecha.length == 0) || this.field == null ) {

        } else {
            this.actualizarRevisionYFecha()
        }


    }

    mostrarContenido() {

        this.imprimirService.getAnexo(this.fecha, this.field ).toPromise().then(( resp: any ) => {

                try {

                if( resp[0]['fecha_anexo'] === undefined ){
                    this.anexo = new Date();
                }else{
                    this.anexo = resp[0]['fecha_anexo'];
                }
                } catch (error) {
                    this.anexo = new Date();
                }

                 try {

                if( resp[0]['rev'] === undefined ){
                    this.rev = 'X';
                }else{
                    this.rev = resp[0]['rev'];
                }
                } catch (error) {
                    this.rev = 'X';
                }
               });

    }

    actualizarRevisionYFecha(): void{
        const resultado = this.obtenerRevisionAplicable(this.fecha)
        if(resultado) {
            this.numRevision = resultado.rev;
            this.fechaRevision = resultado.fecha_anexo;
        } else {
            this.numRevision = '';
            this.fechaRevision = null;
        }

        this.fechaRevisionValid = this.isValidate(this.fechaRevision)
        this.fechaValid = this.isValidate(this.fecha)
    }

    obtenerRevisionAplicable(fechaInforme: string): {rev:string, fecha_anexo:string} | null{
        const fechaInformeDate = new Date(fechaInforme)
        const revisionesOrdenadas = this.arrayRevisiones.sort((a,b) => new Date(a.fecha_anexo).getTime() - new Date(b.fecha_anexo).getTime())
        const revisionesAnteriores = revisionesOrdenadas.filter(revision => new Date(revision.fecha_anexo) <= fechaInformeDate)

        if (revisionesAnteriores.length > 0){
            const revisionAplicable = revisionesAnteriores[revisionesAnteriores.length - 1]
            return {rev: revisionAplicable.rev, fecha_anexo: revisionAplicable.fecha_anexo}
        }else{
            return
        }

    }

    isValidate(date:string) : boolean{
        const parsedDate = Date.parse(date)
        return !isNaN(parsedDate)
    }



}

